import { Container, Suport } from "./styles.js";

import ForgotPassView from "../../views/ForgotPass/index.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
function ForgotPass() {
  return (
    <Container>
      <ForgotPassView />
             <Suport href="https://wa.me/5547991153595" target="_blank">
                          <u>Suporte</u>
                          <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
                        </Suport>
    </Container>
  );
}

export default ForgotPass;
